var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05366 19.006H6.35801L14.9232 10.4348L13.6189 9.13045L5.05366 17.7016V19.006ZM19.3238 8.99075L15.0439 4.7549L16.2765 3.5163C16.7156 3.07318 17.2502 2.85063 17.8803 2.84865C18.5104 2.84665 19.047 3.06521 19.4901 3.50435L20.6808 4.6951C21.0961 5.10235 21.306 5.58776 21.3107 6.15135C21.3154 6.71495 21.1182 7.19638 20.7189 7.59565L19.3238 8.99075ZM17.8798 10.4598L7.24388 21.0956H2.95801V16.8157L13.5939 6.1799L17.8798 10.4598ZM14.277 9.7826L13.6189 9.13045L14.9232 10.4348L14.277 9.7826Z",
    fill: "#1D5AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.e993025bf86189d643bd4525366c68b6.svg";
export { ForwardRef as ReactComponent };